/**
 * R2-BR-D05: Val's starter prompts must fit the workspace the user is
 * actually in. Pre-fix, Individual workspaces got org-product chips
 * ("Find SBIR opportunities for us") alongside the org list.
 */
export const ORG_STARTERS = [
  'What can you help me with?',
  'Find SBIR opportunities for us',
  'What deadlines are coming up?',
  'Take me to my pipeline',
  'How do fit scores work?',
] as const;

export const INDIVIDUAL_STARTERS = [
  'What can you help me with?',
  'What am I tracking?',
  'What funding fits me?',
  'What deadlines do I have coming up?',
  'How do match scores work?',
] as const;

/** Individual workspaces live under /app/individual — every other app route is org-side. */
export function starterPromptsForPath(pathname: string): readonly string[] {
  return pathname.startsWith('/app/individual') ? INDIVIDUAL_STARTERS : ORG_STARTERS;
}
